<template>
  <div class="content">
    <el-row style="width: 100%;height: 1.6rem;background-color: #ffffff">
      <el-col :span="5" style="height: 100%">
        <div class="doctor-img">
          <img :src="$route.query.doctorImg?$route.query.doctorImg:'static/img/doctor.png'"/>
        </div>
      </el-col>
      <el-col :span="19" style="font-size: .28rem">
        <div style="height: .5rem;line-height: .75rem;font-size: .3rem">{{$route.query.name}}-{{$route.query.ksname}}</div>
        <div style="color: #555555;line-height: .65rem;height: .5rem;font-size: .28rem">{{$route.query.profession}}</div>
        <el-row>
          <el-col :span="9">
            <div style="height: .5rem;line-height: .55rem;font-size: .28rem;color: #999999">线上接诊：{{$route.query.count}}</div>
          </el-col>
          <el-col :span="15">
            <el-rate class="doctor-rate" v-model="rate" disabled text-color="#ff9900"></el-rate>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div style="background-color: #ffffff;margin-top: .1rem">
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="排班信息" name="first">
          <dateTabs :cIndex="cIndex" @changDate="changDate"></dateTabs>
          <div v-if="registrationListBydate.length>0" v-for="(item,index) in registrationListBydate" :key="index">
            <div v-if="!hyType">
              <div v-if="!item.时段余号数量==0" @click="toConfirmRegistration(item)">
                <el-row style="width: 100%;height: 1rem;border-bottom: 1px #f0f0f0 solid;">
                  <el-col :span="12" style="margin-left: .3rem">
                    <div style="line-height: 1rem;color: #409eff;font-size: .3rem">{{date}} {{item.时间段}}</div>
                  </el-col>
                  <el-col :span="4" style="line-height: 1rem;text-align: right;font-size: .3rem;color: #e6a23c">￥{{item.金额}}</el-col>
                  <el-col :span="5" style="height: 1rem;display: flex;align-items: center;justify-content: flex-end">
                    <div style="background-color: #409eff;text-align: center;border-radius: .2rem;color: #ffffff;font-size: .24rem;width: 1.2rem;height:.4rem;line-height: .4rem">余号:{{item.时段余号数量}}</div>
                  </el-col>
                  <el-col :span="2" style="height:.9rem;line-height: 1.04rem;font-size: .28rem;text-align: center">
                    <i class="el-icon-arrow-right" style="font-weight: 900;color: #8a8a8a;font-size: .32rem;line-height: .4rem"></i>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div v-if="hyType">
              <div v-if="!item.时段余号数量==0"@click="toConfirmRegistration(item)" >
                <el-row style="width: 100%;height: 1rem;border-bottom: 1px #f0f0f0 solid;">
                  <el-col :span="12" style="margin-left: .3rem">
                    <div style="line-height: 1rem;color: #409eff;font-size: .3rem">{{date}} {{item.时间段}}</div>
                  </el-col>
                  <el-col :span="4" style="line-height: 1rem;text-align: right;font-size: .3rem;color: #e6a23c">￥{{item.金额}}</el-col>
                  <el-col :span="5" style="height: 1rem;display: flex;align-items: center;justify-content: flex-end">
                    <div style="background-color: #409eff;text-align: center;border-radius: .2rem;color: #ffffff;font-size: .24rem;width: 1.2rem;height:.4rem;line-height: .4rem">余号:{{item.时段余号数量}}</div>
                  </el-col>
                  <el-col :span="2" style="height:.9rem;line-height: 1.04rem;font-size: .28rem;text-align: center">
                    <i class="el-icon-arrow-right" style="font-weight: 900;color: #8a8a8a;font-size: .32rem;line-height: .4rem"></i>
                  </el-col>
                </el-row>
              </div>
              <div v-if="item.时段余号数量==0">
                <el-row style="width: 100%;height: 1rem;background-color: #f4f4f4;border-bottom: 1px #dddddd solid;">
                  <el-col :span="12" style="margin-left: .3rem">
                    <div style="line-height: 1rem;color: rgb(153, 153, 153);font-size: .3rem">{{date}} {{item.时间段}}</div>
                  </el-col>
                  <el-col :span="4" style="line-height: 1rem;text-align: right;font-size: .3rem;color: rgb(153, 153, 153)">￥{{item.金额}}</el-col>
                  <el-col :span="5" style="height: 1rem;display: flex;align-items: center;justify-content: flex-end">
                    <div style="background-color: #dddddd;text-align: center;border-radius: .2rem;color: rgb(153, 153, 153);font-size: .24rem;width: 1rem;height:.4rem;line-height: .39rem">约满</div>
                  </el-col>
                  <el-col :span="2" style="height:.9rem;line-height: 1.06rem;font-size: .28rem;text-align: center">
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="noCard" v-if="!registrationListBydate.length>0">
            <div class="noCard-img">
              <img src="static/img/noCard.png"/>
            </div>
            <div class="noCard-text">暂无号源</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="医生简介" name="second">
          <div>
            <div style="border-bottom: 1px #f0f0f0 solid;">
              <el-row style="width: 100%;">
                <el-col :span="3">
                  <div class="introduce-left">
                    <img src="static/img/shanchang.png" class="introduce-icon"/>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="introduce-right">擅长</div>
                </el-col>
              </el-row>
              <div class="introduce-details">
                {{$route.query.introduce}}
              </div>
            </div>
            <div style="border-bottom: 1px #f0f0f0 solid;" v-if="$route.query.desc">
              <el-row style="width: 100%;">
                <el-col :span="3">
                  <div class="introduce-left">
                    <img src="static/img/jianjie.png" class="introduce-icon"/>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="introduce-right">简介</div>
                </el-col>
              </el-row>
              <div class="introduce-details">
                {{$route.query.desc}}
              </div>
            </div>
            <div style="border-bottom: 1px #f0f0f0 solid;">
              <el-row style="width: 100%;">
                <el-col :span="3">
                  <div class="introduce-left">
                    <img src="static/img/pingjia.png" class="introduce-icon"/>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="introduce-right">患者评价</div>
                </el-col>
              </el-row>
              <div class="introduce-details">
                "医术精湛，妙手回春"
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="btn-all" v-if="activeName=='first'" @click="changeType">{{hyText}}</div>
  </div>
</template>

<script>
  import dateTabs from '../common/DateTabs'
  import {gethaoyuanYs} from '../../api/index'
    export default {
      data(){
        return{
          rate:5,
          activeName:'first',
          registrationList:[],
          registrationListBydate:[],
          date:'今天',
          hyType:false,//全部号源or可用号源
          hyText:'查看所有号源',
          cIndex:0,
        }
      },
      components:{
        dateTabs
      },
      created() {
        //修改标题
        document.title = '医生详情'
        this.cIndex = this.$route.query.cIndex
        if(this.$route.query.cIndex != 0){
          this.date = this.$route.query.cDate.substring(5,this.$route.query.cDate.length)
        }
        this.gethaoyuanYs()
      },
      methods:{
        gethaoyuanYs(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          gethaoyuanYs({
            ysId:this.$route.query.doctorId,
            ksId:this.$route.query.ksId
          }).then(res=>{
            loading.close();
            this.registrationList = res.Data
            this.registrationListBydate = res.Data.filter(item => item.日期 == this.getDateYYMMDD(this.$route.query.cDate))
          })
        },
        gethaoyuanYsBydate(date){
          this.registrationListBydate = this.registrationList.filter(item => item.日期 == date)
        },
        //切换时间
        changDate(date){
          this.date = date.value
          this.gethaoyuanYsBydate(date.date)
        },
        //切换 全部号源/可用号源
        changeType(){
          this.hyText = this.hyType?'查看所有号源':'只看可用号源'
          this.hyType = !this.hyType
        },
        //获取date的年-月-日
        getDateYYMMDD(date){
          let myDate = new Date(date)
          let yy = myDate.getFullYear();
          let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          return yy + '-' +mm + '-' + dd
        },
        toConfirmRegistration(item){
          if(!this.$storage.get('patient')){
            this.$confirm('你还没有健康卡, 是否去注册?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({path:'/personManage'})
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
                duration:3000,
                center:true,
                offset:200
              });
            });
            return
          }
          this.$router.push({path:'/confirmRegistration',query:{
              date:item.日期,
              dated:item.时间段,
              ks:this.$route.query.ksname,
              ksId:item.科室ID,
              doctor:this.$route.query.name,
              doctorId:item.医生ID,
              money:item.金额,
              hyxlh:item.号源序列号,
              pbxlh:item.排班序列号
            }})
        },

      }
    }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
  .content{
    background-color: #f4f4f4;
    width: 100%;
    height: 100vh;
    position: relative;
    font-size: .3rem;
  }
  .doctor-img{
    width: 1rem;
    height: 1.3rem;
    margin: .15rem auto;
    border-radius: .3rem;
  }
  .doctor-img img{
    width: 100%;
    height: 100%;
    border-radius: .3rem;
  }
  .doctor-rate{
    height: .5rem;
    display: flex;
    align-items: center;
    /*去除点击有蓝色边框*/
    outline:none;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 1rem 0 3rem 0;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
  .introduce-left{
    height: .4rem;
    width: .4rem;
    margin: .22rem auto 0 auto;
    font-size: .32rem;
  }
  .introduce-right{
    height: .7rem;
    width: 100%;
    line-height: .8rem;
    font-size: .32rem;
  }
  .introduce-icon{
    width: 100%;
    height: 100%;
  }
  .introduce-details{
    font-size: .3rem;
    padding: 0 .2rem .2rem .9rem;
    color: #999999;
  }
  .btn-all{
    background-color: rgb(230, 162, 60);
    width: 3rem;
    height: .5rem;
    line-height: .5rem;
    text-align: center;
    font-size: .26rem;
    border-radius: .4rem;
    position: fixed;
    top:90vh;
    color: #ffffff;
    left: 2.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/doctorDetails.vue